import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles((theme) => ({
  draggableChoice: {
    backgroundColor: 'none',
    transition: 'background-color 200ms ease-in-out',

    '&.dragging': {
      backgroundColor: '#f1f2f3',
    },
  },
  listButton: {
    color: 'rgba(0, 0, 0, 0.54)',
    width: '141px',

    '&.listButtonDisabled': {
      color: theme.palette.primary.main,
    },
  },
  reviewIcon: {
    backgroundColor: '#F39A47',
    borderRadius: '10px',
    width: '10px',
    height: '10px',
    marginRight: '20px',
  },
}));

export default useStyles;
